import { camelCase, capitalize } from 'lodash';
import { ColumnProperties } from '../types/Column';

export interface CsvHeader {
  label: string;
  key: string;
}

export const getCsvHeader = (columns: ColumnProperties[]): CsvHeader[] =>
  columns
    .filter((column) => column.checked)
    .map((column) => ({
      label: capitalize(column.name),
      key: camelCase(column.name)
    }));
